import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'

export interface TenantPublicInfo {
  id: string
  slug: string
  name: string
}

export const TenantLookupService = (client: AxiosInstance) => {
  return {
    async getById(tenantId: string): Promise<TenantPublicInfo> {
      const { data } = await wrapApiCall(() =>
        client.get<TenantPublicInfo>(`/public/tenants/${encodeURIComponent(tenantId)}/info`)
      )
      return data
    },
  }
}
